import React from 'react';
import {
  AlertTriangle,
  Phone,
  Users,
  User,
  Clock,
  Calendar,
  Eye,
  EyeOff,
  Shield,
  Lock,
  Key,
  Home,
  MapPin,
  Wrench,
  Battery,
  Droplet,
  Tag,
  PawPrint,
  Construction
} from 'lucide-react';

export const FLAG_ICON_OPTIONS = [
  { value: 'AlertTriangle', label: 'Alert', Icon: AlertTriangle },
  { value: 'Phone', label: 'Phone', Icon: Phone },
  { value: 'Users', label: 'Two Person', Icon: Users },
  { value: 'User', label: 'Single Person', Icon: User },
  { value: 'Clock', label: 'Call Before Arriving', Icon: Clock },
  { value: 'Calendar', label: 'Schedule Sensitive', Icon: Calendar },
  { value: 'Eye', label: 'Visible Cues', Icon: Eye },
  { value: 'EyeOff', label: 'Do Not Disturb', Icon: EyeOff },
  { value: 'Shield', label: 'Safety', Icon: Shield },
  { value: 'Lock', label: 'Locked Access', Icon: Lock },
  { value: 'Key', label: 'Key Required', Icon: Key },
  { value: 'Home', label: 'Residential', Icon: Home },
  { value: 'MapPin', label: 'Location Note', Icon: MapPin },
  { value: 'Wrench', label: 'Equipment Note', Icon: Wrench },
  { value: 'Battery', label: 'Battery Note', Icon: Battery },
  { value: 'Droplet', label: 'Fluid Note', Icon: Droplet },
  { value: 'Tag', label: 'General', Icon: Tag },
  { value: 'PawPrint', label: 'Pets', Icon: PawPrint },
  { value: 'Construction', label: 'Ladder', Icon: Construction }
];

const flagIconMap = FLAG_ICON_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.Icon;
  return acc;
}, {});

export const FlagIcon = ({ iconName, className, title }) => {
  const Icon = flagIconMap[iconName] || Tag;
  return React.createElement(Icon, { className, title });
};
